Vue.component("assistant-pages",
    {
        props: [
            "pid",
            "contact",
            "systemContractType",
            "contractWhitelist",
            "referrer",
            "translations",
            "refContractType",
            "localizationData",
            "showPlentyBi"
        ],

        template: "#vue-assistant-pages",

        created()
        {
            this.$store.commit("setPid", this.pid);
            this.$store.commit("setContact", this.contact);
            this.$store.commit("setReferrer", this.referrer);
            this.$store.commit("setTagReferrer", this.referrer);
            this.$store.commit("setTranslation", this.translations);
            this.$store.commit("setRefContractType", this.refContractType);
            this.$store.commit("setLocalizationData", this.localizationData);
            this.$store.commit("setSystemContractType", this.systemContractType);
            this.$store.commit("setContractWhitelist", this.contractWhitelist);
            this.$store.commit("setShowPlentyBiPage", this.showPlentyBi);
        },

        ready()
        {
            this.prepareDataPlacements();

            if (!this.pid)
            {
                this.jumpTo(1);
            }
        },

        data()
        {
            return {
                currentPage: 0
            };
        },

        computed: {
            ...Vuex.mapGetters(
                {
                    trans: "getTranslation"
                }
            )
        },

        methods: {

            prepareDataPlacements()
            {
                const nodeList = document.getElementsByClassName("assistant-page");

                for (let i = 0; i < nodeList.length; i++)
                {
                    nodeList[i].dataset.placement = i.toString();
                }

                const stepperNodeList = document.getElementsByClassName("form-wizard-step");

                for (let i = 0; i < stepperNodeList.length; i++)
                {
                    stepperNodeList[i].dataset.placement = `${i + 1}`;
                }
            },

            /**
             * Page navigation of checkout
             * @param direction "next" or "prev"
             */
            navAction(direction)
            {
                const activeNode = document.getElementsByClassName("assistant-page show")[0];
                const nodeList = document.getElementsByClassName("assistant-page");

                let nodeIndex = activeNode.dataset.placement;

                if (direction === "prev")
                {
                    nodeIndex--;
                    this.currentPage--;
                }
                else if (direction === "next")
                {
                    nodeIndex++;
                    this.currentPage++;
                }

                document.getElementsByClassName("assistant-pages")[0].className =
                    document.getElementsByClassName("assistant-pages")[0].className
                        .replace("page-" + activeNode.dataset.placement, "page-" + nodeIndex);

                activeNode.className = activeNode.className.replace(" show", "");
                nodeList[nodeIndex].className += " show";

                this.updateStepWizard();

                Vue.nextTick(() =>
                {
                    $("[data-toggle='tooltip']").tooltip();
                });

            },

            jumpTo(page)
            {
                if (document.getElementsByClassName("form-wizard-step").length > this.currentPage)
                {
                    const activeNode = document.getElementsByClassName("assistant-page show")[0];
                    const nodeList = document.getElementsByClassName("assistant-page");

                    document.getElementsByClassName("assistant-pages")[0].className =
                        document.getElementsByClassName("assistant-pages")[0].className
                            .replace("page-" + activeNode.dataset.placement, "page-" + page);

                    activeNode.className = activeNode.className.replace(" show", "");
                    nodeList[page].className += " show";

                    this.currentPage = page;

                    this.updateStepWizard();
                }
            },

            /**
             * Updates step wizard
             */
            updateStepWizard()
            {
                const formStepList = document.getElementsByClassName("form-wizard-step");

                for (const formStep of formStepList)
                {
                    const stepIndex = parseInt(formStep.dataset.placement);

                    if (stepIndex > this.currentPage)
                    {
                        formStep.classList.remove("active", "complete");
                        formStep.classList.add("disabled");
                    }
                    else if (stepIndex === this.currentPage)
                    {
                        formStep.classList.remove("disabled", "complete");
                        formStep.classList.add("active");
                    }
                    else if (stepIndex < this.currentPage)
                    {
                        formStep.classList.remove("disabled", "active");
                        formStep.classList.add("complete");
                    }
                }

                if (this.currentPage === formStepList.length)
                {
                    document.getElementsByClassName("form-wizard")[0].classList.add("finished");
                }
                else
                {
                    document.getElementsByClassName("form-wizard")[0].classList.remove("finished");
                }

            }
        }
    });
